
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Qu'en est-il en Suisse?`}</em></p>
    <p>{`5,3 millions de doses ont été commandées, mais le produit n’est
`}<a parentName="p" {...{
        "href": "https://www.admin.ch/gov/fr/accueil/documentation/communiques.msg-id-82221.html"
      }}>{`pas approuvé par Swissmedic`}</a>{`.`}</p>
    <p>{`Début février 2021, l’institut suisse des produits thérapeutiques a indiqué que
“des données issues de nouvelles études sont requises pour évaluer plus avant la
sécurité, l’efficacité et la qualité”.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;